<script>

export default({
  name: "rfq-statewide-make"
})
</script>

<template>
  <div>
    <div class="cards-statewide d-flex" style="margin-top: 40px">
      <div class="card-statewide" @click="$emit('selected', 'Alfa Romeo')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/alfa-romeo.png" height="105" width="105"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'Audi')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/audi.png" height="120" width="120"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'BMW')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/bmw.webp" height="120" width="120"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'BYD')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/byd.png" height="70" width="140"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'Cupra')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/cupra.png" height="75" width="120"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'Chrysler')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/chrysler.png" height="35" width="120"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'Chery')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/chery.webp" height="93" width="130"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'Fiat')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/fiat.png" height="90" width="120"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'Ford')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/ford.png" height="45" width="120"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'GWM')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/gwm.png" height="70" width="120"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'Holden')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/holden.png" height="120" width="120"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'Hyundai')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/hyundai.png" height="70" width="120"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'Isuzu')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/isuzu.png" height="40" width="120"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'Jac')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/jac.png" height="120" width="120"/>
        </div>
      </div>

      <div class="card-statewide" @click="$emit('selected', 'Jaguar')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/jaguar.png" height="60" width="120"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'Jeep')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/jeep.png" height="110" width="140"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'Kia')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/kia.png" height="50" width="120"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'Land-Rover')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/land-rover.png" height="70" width="120"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'LDV')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/ldv.png" height="100" width="150"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'Lexus')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/lexus.png" height="73" width="120"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'Mazda')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/mazda.png" height="120" width="120"/>
        </div>
      </div>

      <div class="card-statewide" @click="$emit('selected', 'Mersedes-Benz')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/mersedes-benz.png" height="120" width="120"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'Mini')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/mini.png" height="120" width="120"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'Mitsubishi')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/mitsubishi.png" height="120" width="120"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'MG')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/mg.png" height="120" width="120"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'Nissan')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/nissan.png" height="90" width="120"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'Polestar')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/polestar.png" height="80" width="140"/>
        </div>
      </div>

      <div class="card-statewide" @click="$emit('selected', 'Porshe')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/porshe.png" height="105" width="92"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'RAM')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/ram.png" height="100" width="90"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'Renault')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/renault.png" height="120" width="120"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'Ssangyong')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/ssangyong.png" height="80" width="120"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'Suzuki')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/suzuki.png" height="110" width="110"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'Toyota')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/toyota.png" height="120" width="140"/>
        </div>
      </div>

      <div class="card-statewide" @click="$emit('selected', 'Volkswagen')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/volkswagen.png" height="100" width="100"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'Volvo')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/volvo.png" height="125" width="125"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'Abarth')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/abarth.png" height="130" width="200"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'Aston Martin')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/aston-martin.png" height="55" width="120"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'Bentley')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/bentley.png" height="58" width="120"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'Brabus')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/brabus.png" height="115" width="120"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'Ferrari')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/ferrari.png" height="120" width="85"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'Lamborghini')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/lamborghini.png" height="100" width="105"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'Lotus')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/lotus.png" height="105" width="105"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'McLaren')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/mclaren.png" height="35" width="140"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'Morgan')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/morgan.png" height="70" width="130"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'Pagani')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/pagani.png" height="63" width="120"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'Singer')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/singer.png" height="50" width="120"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'Sikkens')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/sikkens.png" height="65" width="120"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', '3M')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/3m.png" height="100" width="125"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'Ppg')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/ppg.png" height="165" width="180"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'Hayman-Reese')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/hayman-reese.png" height="120" width="120"/>
        </div>
      </div>
      <div class="card-statewide" @click="$emit('selected', 'Kovax')">
        <div class="card-statewide-brand">
          <img src="../../../../../public/img/auto-logo/kovax.png" height="40" width="120"/>
        </div>
      </div>
    </div>
    <button @click="$emit('cancelPage')" style="margin-top: 30px" class="btn btn-outline-primary pull-right button-cancel">Cancel</button>
  </div>

</template>

<style scoped>
.cards-statewide{
  flex-wrap: wrap;
  justify-content: space-between;
}
.card-statewide{
  border: 1px solid black;
  margin: 5px;
  padding: 10px 0;
  width: 138px;
  position: relative;
  height: 130px;
  cursor: pointer;
}
.card-statewide:hover{
  background-color: #f0f2f1;
}
.card-statewide img {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
}
</style>